<template>
  <div class="wt2-confirm-duplicate wt2-select-programmer wt2-modal-inner">
    <div class="-title wt2-text-l2" v-text="title" />
    <small v-text="message" />

    <div class="-programmer">
      <span class="wt2-color-black">{{
        'makeCopyDialog.productionLine' | culture
      }}</span>
      <wt-programmers-dropdown
        :organization-id="selectedOrganizationId"
        :current-programmer-id.sync="currentProgrammerId"
        :show-single-programmer="true"
      />
    </div>
    <div class="-actions" v-tab-guard>
      <wt-button
        class="-min-width-unset"
        tabindex="0"
        type="transparent"
        :text="'generic.CANCEL' | culture"
        @click="closeModal"
      />
      <wt-button tabindex="-1" :text="buttonText" @click="select" />
    </div>
  </div>
</template>

<script>
import app from 'app';

import { mapState } from 'vuex';

export default {
  name: 'wt-select-programmer',

  store() {
    return app.rootStore;
  },

  props: {
    closeModal: { type: Function, required: true },
    title: { type: String, default: app.culture.makeCopyDialog.title },
    buttonText: {
      type: String,
      default: app.culture.translateOnShortcutDialog.buttonText,
    },
    message: { type: String, required: true },
    selectedProgrammerId: { type: Number, required: true },
    onSelected: { type: Function, required: true },
  },

  data() {
    return {
      currentProgrammerId: null,
    };
  },

  computed: {
    ...mapState('user', ['selectedOrganizationId']),
  },

  created() {
    this.currentProgrammerId = this.selectedProgrammerId;
  },

  methods: {
    select() {
      const programmerName = this.currentProgrammerId
        ? app.programmers.get(this.currentProgrammerId)?.get('programmerName')
        : null;
      this.onSelected({
        programmerName,
        closeModal: this.closeModal,
      });
    },
  },
};
</script>
